<p-confirmDialog></p-confirmDialog>
<form (ngSubmit)="search()" style="width: 100%">
  <!--DEPLYMENT TAB FILTER-->
  <div *ngIf="inboxType == type_inboxDeploy" class="form-grid filterPanel form-group">
    <div class="">
      <span class="md-inputfield filterItem">
        <input name="regNo" type="text" pInputText [(ngModel)]="filterVal.filters.regNo.value" />
        <label>Reg.No.</label>
      </span>
    </div>

    <div class="">
      <span class="md-inputfield filterItem">
        <input name="from" type="text" pInputText [(ngModel)]="filterVal.filters.from.value" />
        <label>From</label>
      </span>
    </div>

    <div class="">
      <span class="md-inputfield filterItem">
        <input name="to" type="text" pInputText [(ngModel)]="filterVal.filters.to.value" />
        <label>To</label>
      </span>
    </div>

    <div class="">
      <p-multiSelect
        name="taskTypes"
        [options]="taskTypes"
        [(ngModel)]="filterVal.filters.taskTypeList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Customer Task Types"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="customers"
        [options]="customers"
        [(ngModel)]="filterVal.filters.customerIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="Customers"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="eareas"
        [options]="eareas"
        [(ngModel)]="filterVal.filters.eAreaIdList.value"
        (onChange)="populateERegions()"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Regions"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="eregions"
        [options]="eregions"
        [(ngModel)]="filterVal.filters.eRegionIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Areas"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-dropdown
        name="stages"
        [options]="stages"
        [(ngModel)]="filterVal.filters.stage.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="">
      <p-multiSelect
        name="deployPriority"
        [options]="deployPriorityGradings"
        [(ngModel)]="filterVal.filters.deployPriorityGradingIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      >
        <ng-template let-grade pTemplate="item">
          <ng-template
            *ngTemplateOutlet="gradingDisplay; context: { $implicit: gradings.get(grade.value) }"
          >
          </ng-template>
        </ng-template>
        <ng-template let-value pTemplate="selectedItems">
          <span *ngFor="let val of value">
            {{ gradings.get(val).description }}
          </span>
          <span
            *ngIf="!value || value.length === 0"
            class="ui-multiselected-empty-token ui-corner-all"
            >All Priorities</span
          >
        </ng-template>
      </p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="tags"
        [options]="tagsOptions"
        [(ngModel)]="filterVal.filters.selectedTagList.value"
        (onChange)="onTaggingChange($event)"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      >
        <ng-template let-tag pTemplate="item">
          <span>{{ tagingsMap.get(tag.value).name }}</span>
        </ng-template>
        <ng-template let-value pTemplate="selectedItems">
          <span *ngFor="let val of value">
            {{ tagingsMap.get(val).name }}
          </span>
          <span
            *ngIf="!value || value.length === 0"
            class="ui-multiselected-empty-token ui-corner-all"
            >Tags</span
          >
        </ng-template>
      </p-multiSelect>
    </div>

    <div class="">
      <div style="margin-top: 10px; margin-right: 7px; font-size: 13px; display: inline-block">
        <p-checkbox
          [(ngModel)]="filterVal.filters.urgentOnly.value"
          name="urgentOnly"
          binary="true"
          label="Urgent Only"
        ></p-checkbox>
      </div>
      <div style="margin-top: 10px; margin-right: 7px; font-size: 13px; display: inline-block">
        <p-checkbox
          [(ngModel)]="filterVal.filters.priorityOnly.value"
          name="priorityOnly"
          binary="true"
          label="Priority Only"
        ></p-checkbox>
      </div>
    </div>

    <div class="">
      <div style="margin-top: 10px; margin-right: 7px; font-size: 13px; display: inline-block">
        <p-checkbox
          [(ngModel)]="filterVal.filters.rescheduledOnly.value"
          name="rescheduledOnly"
          binary="true"
          label="Rescheduled Only"
        ></p-checkbox>
      </div>
    </div>

    <div class="">
      <div style="margin-top: 10px; margin-right: 7px; font-size: 13px; display: inline-block">
        <p-checkbox
          [(ngModel)]="filterVal.filters.delayedOnly.value"
          name="delayedOnly"
          binary="true"
          label="Customer Update Only"
        ></p-checkbox>
      </div>
    </div>

    <div>
      <button pButton type="submit" icon="ui-icon-search" style="border-radius: 5%"></button>
      <button
        pButton
        type="button"
        icon="ui-icon-refresh"
        (click)="refresh()"
        style="border-radius: 5%"
      ></button>
      <button
        pButton
        type="button"
        icon="ui-icon-close"
        (click)="clearFilter(dataTable)"
        style="border-radius: 5%"
      ></button>
    </div>
  </div>

  <!--NON DEPLOYMENT TAB FILTER-->
  <div *ngIf="inboxType != type_inboxDeploy" class="form-grid filterPanel form-group">
    <div class="">
      <span class="md-inputfield filterItem">
        <input name="regNo" type="text" pInputText [(ngModel)]="filterVal.filters.regNo.value" />
        <label>Reg.No.</label>
      </span>
    </div>

    <div class="">
      <span class="md-inputfield filterItem">
        <input name="from" type="text" pInputText [(ngModel)]="filterVal.filters.from.value" />
        <label>From Location</label>
      </span>
    </div>

    <div class="">
      <span class="md-inputfield filterItem">
        <input name="to" type="text" pInputText [(ngModel)]="filterVal.filters.to.value" />
        <label>To Location</label>
      </span>
    </div>

    <div class="">
      <p-multiSelect
        name="taskTypes"
        [options]="taskTypes"
        [(ngModel)]="filterVal.filters.taskTypeList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Customer Task Types"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="actualTaskTypes"
        [options]="taskTypes"
        [(ngModel)]="filterVal.filters.actualTaskTypeList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Engineius Service Types"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="customers"
        [options]="customers"
        [(ngModel)]="filterVal.filters.customerIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Customers"
      ></p-multiSelect>
    </div>

    <div *ngIf="!isHideSupplierFilter()" class="">
      <p-multiSelect
        name="suppliers"
        [options]="suppliers"
        [(ngModel)]="filterVal.filters.supplierIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Suppliers"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="eareas"
        [options]="eareas"
        [(ngModel)]="filterVal.filters.eAreaIdList.value"
        (onChange)="populateERegions()"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Regions"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="eregions"
        [options]="eregions"
        [(ngModel)]="filterVal.filters.eRegionIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Areas"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="customerDepartments"
        [options]="customerDepartments"
        [(ngModel)]="filterVal.filters.customerDepartmentList.value"
        (onChange)="loadCustomerTeams()"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="Customer Department"
      ></p-multiSelect>
    </div>

    <div class="">
      <p-multiSelect
        name="customerTeams"
        [options]="customerTeams"
        [(ngModel)]="filterVal.filters.customerTeamList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="Customer Team"
      ></p-multiSelect>
    </div>

    <div
      class=""
      *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_GlobalFilter"
    >
      <p-dropdown
        name="stages"
        [options]="stages"
        [(ngModel)]="filterVal.filters.stage.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div
      *ngIf="inboxType == type_inboxCompletedJobs"
      class=""
      style="margin-top: auto; margin-bottom: auto"
    >
      <p-checkbox
        [(ngModel)]="filterVal.filters.failedTasks.value"
        name="tasksFailed"
        binary="true"
        label="Require Failure Reason Only?"
      ></p-checkbox>
    </div>

    <div
      *ngIf="inboxType == type_inboxCompletedJobs"
      class=""
      style="margin-top: auto; margin-bottom: auto"
    >
      <p-checkbox
        [(ngModel)]="filterVal.filters.unverifiedOnly.value"
        name="unverified"
        binary="true"
        label="Unverified Jobs Only?"
      ></p-checkbox>
    </div>

    <div
      class=""
      *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_GlobalFilter"
    >
      <p-dropdown
        name="stages"
        [options]="stages"
        [(ngModel)]="filterVal.filters.stage.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="" *ngIf="inboxType == type_inboxCancelled">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.cancelledDateFrom.value"
          name="cancelledDateFrom"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>Cancelled Date From</label>
      </span>
    </div>

    <div class="" *ngIf="inboxType == type_inboxCancelled">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.cancelledDateTo.value"
          name="cancelledDateTo"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>Cancelled Date To</label>
      </span>
    </div>

    <div class="" *ngIf="inboxType == type_inboxClosed">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.completedDateFrom.value"
          name="completedDateFrom"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>Completed Date From</label>
      </span>
    </div>

    <div class="" *ngIf="inboxType == type_inboxClosed">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.completedDateTo.value"
          name="completedDateTo"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>Completed Date To</label>
      </span>
    </div>

    <div class="square-buttons">
      <button pButton type="submit" icon="ui-button-icon-left ui-clickable ui-icon-search"></button>
      <button
        pButton
        type="button"
        icon="ui-button-icon-left ui-clickable ui-icon-refresh"
        (click)="refresh()"
      ></button>
      <button
        pButton
        type="button"
        icon="ui-button-icon-left ui-clickable ui-icon-close"
        (click)="clearFilter(dataTable)"
      ></button>
    </div>
  </div>
</form>

<p-progressBar
  *ngIf="showProgress || isLoading"
  mode="indeterminate"
  class="ui-progressbar-indeterminate"
></p-progressBar>

<p-table
  #dataTable
  [selectionMode]="inboxType == type_inboxDeploy ? 'multiple' : 'single'"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
  [value]="page.items"
  [rows]="20"
  [responsive]="true"
  [first]="filterVal.first"
  [paginator]="inboxType != type_inboxCombine"
  rowHover="true"
  [lazy]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
  [pageLinks]="8"
  [totalRecords]="page.total"
  [hidden]="!isLoaded"
  (onLazyLoad)="onGridLazyLoad($event)"
  resizableColumns="true"
  (onRowSelect)="onRowSelect($event)"
  [metaKeySelection]="true"
  [(selection)]="selectedJobs"
  (selectionChange)="onJobSelectionChange($event)"
  styleClass="inbox-data-table dataTable"
  [loading]="isLoading"
>
  <ng-template pTemplate="header">
    <tr class="no-wrap-cells">
      <th pResizableColumn *ngIf="inboxType == type_inboxCombine" style="width: 30px">&nbsp;</th>
      <th
        pResizableColumn
        pSortableColumn="deployPriorityGrading.description"
        style="width: 30px"
        *ngIf="
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxCombine ||
          inboxType == type_inboxAwaitingStart
        "
      >
        &nbsp;
        <p-sortIcon field="deployPriorityGrading.description"></p-sortIcon>
      </th>
      <th pResizableColumn *ngIf="inboxType == type_inboxCompletedJobs">Status</th>
      <th
        pResizableColumn
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs
        "
        style="width: 30px"
      >
        &nbsp;
      </th>

      <th
        pResizableColumn
        *ngIf="
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxLiveJobs ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed
        "
        id="icons-column"
        style="width: 50px"
      ></th>
      <th
        pSortableColumn="scheduledDate"
        pResizableColumn
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_GlobalFilter
        "
      >
        Schedule Date
        <p-sortIcon field="scheduledDate"></p-sortIcon>
      </th>
      <th pSortableColumn="timeLeft" pResizableColumn *ngIf="inboxType == type_inboxDeploy">
        Time Left
        <p-sortIcon field="timeLeft"></p-sortIcon>
      </th>

      <th
        pSortableColumn="lastTaskCompleted"
        pResizableColumn
        *ngIf="inboxType == type_inboxCompletedJobs"
      >
        Job Completed
        <p-sortIcon field="lastTaskCompleted"></p-sortIcon>
      </th>
      <th pSortableColumn="closedDate" pResizableColumn *ngIf="inboxType == type_inboxClosed">
        Job Closed
        <p-sortIcon field="closedDate"></p-sortIcon>
      </th>
      <th
        pSortableColumn="jobLastUpdated"
        pResizableColumn
        *ngIf="inboxType == type_inboxCancelled"
      >
        Job Cancelled Date
        <p-sortIcon field="jobLastUpdated"></p-sortIcon>
      </th>
      <th pSortableColumn="vehicleRegNumber" pResizableColumn>
        Vehicle Reg
        <p-sortIcon field="vehicleRegNumber"></p-sortIcon>
      </th>
      <th pSortableColumn="from" pResizableColumn>
        From
        <p-sortIcon field="from"></p-sortIcon>
      </th>

      <th pSortableColumn="to" pResizableColumn>
        To
        <p-sortIcon field="to"></p-sortIcon>
      </th>

      <th pSortableColumn="pickupZoneName" pResizableColumn>
        Collection Ops Zone
        <p-sortIcon field="pickupZoneName"></p-sortIcon>
      </th>

      <th pSortableColumn="deliveryZoneName" pResizableColumn>
        Delivery Ops Zone
        <p-sortIcon field="deliveryZoneName"></p-sortIcon>
      </th>

      <th
        pResizableColumn
        *ngIf="
          inboxType != type_inboxCompletedJobs &&
          inboxType != type_inboxCancelled &&
          inboxType != type_inboxClosed
        "
        pSortableColumn="earliestPickupDate"
      >
        Earliest Pickup
        <p-sortIcon field="earliestPickupDate"></p-sortIcon>
      </th>

      <th
        pResizableColumn
        *ngIf="
          inboxType != type_inboxCompletedJobs &&
          inboxType != type_inboxCancelled &&
          inboxType != type_inboxClosed
        "
        pSortableColumn="earliestDropoffDate"
      >
        Earliest Dropoff
        <p-sortIcon field="earliestDropoffDate"></p-sortIcon>
      </th>

      <th pSortableColumn="movementType" pResizableColumn>
        Movement Type
        <p-sortIcon field="movementType"></p-sortIcon>
      </th>

      <th
        pSortableColumn="customerName"
        pResizableColumn
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
      >
        Customer
        <p-sortIcon field="customerName"></p-sortIcon>
      </th>
      <th
        pSortableColumn="customerDepartmentName"
        pResizableColumn
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
      >
        Dept
        <p-sortIcon field="customerDepartmentName"></p-sortIcon>
      </th>
      <th
        pSortableColumn="customerTeamName"
        pResizableColumn
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
      >
        Team
        <p-sortIcon field="customerTeamName"></p-sortIcon>
      </th>
      <th
        pSortableColumn="supplierName"
        pResizableColumn
        *ngIf="
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
      >
        Supplier
        <p-sortIcon field="supplierName"></p-sortIcon>
      </th>
      <th pSortableColumn="vehiclesNum" pResizableColumn *ngIf="inboxType != type_inboxDeploy">
        Vehicles
        <p-sortIcon field="vehiclesNum"></p-sortIcon>
      </th>

      <th
        pSortableColumn="binCost"
        pResizableColumn
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_GlobalFilter
        "
      >
        Supplier Price
        <p-sortIcon field="binCost"></p-sortIcon>
      </th>

      <th
        pSortableColumn="supplierPrice"
        pResizableColumn
        *ngIf="inboxType == type_inboxAwaitingStart || inboxType == type_inboxCompletedJobs"
      >
        Supplier Price
        <p-sortIcon field="supplierPrice"></p-sortIcon>
      </th>

      <th pSortableColumn="total" pResizableColumn *ngIf="inboxType == type_inboxCancelled">
        Cust Cancel Fee
        <p-sortIcon field="total"></p-sortIcon>
      </th>

      <th pSortableColumn="total" pResizableColumn *ngIf="inboxType == type_inboxClosed">
        Cust Final Fee
        <p-sortIcon field="total"></p-sortIcon>
      </th>

      <th pSortableColumn="supplierPaid" pResizableColumn *ngIf="inboxType == type_inboxCancelled">
        Supp Cancel Fee
        <p-sortIcon field="supplierPaid"></p-sortIcon>
      </th>

      <th pSortableColumn="supplierPaid" pResizableColumn *ngIf="inboxType == type_inboxClosed">
        Supp Final Fee
        <p-sortIcon field="supplierPaid"></p-sortIcon>
      </th>

      <th
        pResizableColumn
        *ngIf="
          inboxType != type_inboxCompletedJobs &&
          inboxType != type_inboxCancelled &&
          inboxType != type_inboxClosed
        "
      >
        Status
      </th>
      <th pResizableColumn *ngIf="inboxType == type_GlobalFilter">Inbox</th>
      <th
        pResizableColumn
        *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
        pSortableColumn="watchCount"
      >
        Watch Count
        <p-sortIcon field="watchCount"></p-sortIcon>
      </th>
      <th
        pSortableColumn="supplierDirectedCount"
        pResizableColumn
        *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
      >
        Directed
        <p-sortIcon field="supplierDirectedCount"></p-sortIcon>
      </th>
      <th pSortableColumn="binCost" pResizableColumn *ngIf="inboxType == type_inboxDeploy">
        Price
        <p-sortIcon field="binCost"></p-sortIcon>
      </th>
      <th
        pSortableColumn="orderCreatedOn"
        pResizableColumn
        *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
      >
        Order Created
        <p-sortIcon field="orderCreatedOn"></p-sortIcon>
      </th>
      <!--      <th pResizableColumn *ngIf="inboxType == type_inboxDeploy" style="width: 40px"></th>-->
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr (dblclick)="viewJob(row, $event)" [pSelectableRow]="row" class="no-wrap-cells">
      <td
        *ngIf="inboxType == type_inboxCombine"
        style="padding-left: 0px; padding-right: 0px; width: 30px; text-align: center"
      >
        <input type="checkbox" [(ngModel)]="row.checked" />
      </td>
      <td
        *ngIf="
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxCombine ||
          inboxType == type_inboxAwaitingStart
        "
        style="width: 30px; text-align: center"
      >
        <div class="incident-icons" *ngIf="row.deployPriorityGrading">
          <i
            [pTooltip]="row.deployPriorityGrading.description"
            [class]="row.deployPriorityGrading.iconClass"
            [ngStyle]="{ color: row.deployPriorityGrading.colour }"
          ></i>
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxCompletedJobs" style="width: 30px; text-align: center">
        <div *ngIf="row.tasksRequireFailureReason">
          <i
            pTooltip="One or more tasks require a failure reason"
            class="fa fa-lg fa-times-circle"
            style="color: #c00"
          ></i>
        </div>

        <div *ngIf="row.plateVerified">
          <i
            pTooltip="All task plates are verified"
            class="fa fa-lg fa-check"
            style="color: #0c0"
          ></i>
        </div>
        <div *ngIf="!row.plateVerified">
          <i
            pTooltip="One or more task plates are unverified"
            class="fa fa-window-close-o"
            style="color: #b00"
          ></i>
        </div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs
        "
        style="width: 30px; text-align: center"
      >
        <div class="incident-icons">
          <i
            *ngIf="rowHasDelayedTask(row)"
            class="fa fa-flag"
            style="color: #00a0b4"
            pTooltip="Customer Update"
          ></i>
          <i
            *ngIf="row.openMessageCount > 0"
            pTooltip="{{ row.openMessageCount }} Open Incident Messages"
            class="material-icons"
            >mail_outline</i
          >
          <i
            *ngIf="row.openIncidentCount > 0"
            style="color: #ff8f00"
            pTooltip="{{ row.openIncidentCount }} Open Incidents"
            class="material-icons"
            >report_problem</i
          >
        </div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxLiveJobs ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed
        "
      >
        <div class="flex align-content-center gap-1 justify-content-center">
          <route-icon *ngIf="rowIsRoute(row)"></route-icon>
          <span
            *ngIf="
              checkCarryOverAuthorised(row) &&
              (inboxType == type_inboxAwaitingStart ||
                inboxType == type_inboxLiveJobs ||
                inboxType == type_inboxCompletedJobs)
            "
            pTooltip="Carry-Over"
            ><img src="/assets/images/carryOver_icon.png" style="height: 20px"
          /></span>
        </div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_GlobalFilter
        "
        style="width: 8%"
      >
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ row.scheduledDate | datex : 'ddd DD MMM \'YY' }}"
        >
          {{ row.scheduledDate | datex : "ddd DD MMM 'YY" }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxDeploy">
        <div [class.job-unclicked]="!row.clicked">
          {{ row.timeLeft }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxCompletedJobs">
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ row.lastTaskCompleted | datex : 'ddd DD MMM \'YY' }}"
        >
          {{ row.lastTaskCompleted | datex : "ddd DD MMM 'YY" }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxClosed">
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ row.closedDate | datex : 'ddd DD MMM \'YY' }}"
        >
          {{ row.closedDate | datex : "ddd DD MMM 'YY" }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxCancelled">
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ row.jobLastUpdated | datex : 'ddd DD MMM \'YY' }}"
        >
          {{ row.jobLastUpdated | datex : "ddd DD MMM 'YY" }}
        </div>
      </td>
      <td class="text-center">
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ vehicleCountPostfix(row, row.vehicleRegNumberDetails) }}"
        >
          {{ vehicleCountPostfix(row, row.vehicleRegNumber) }}
        </div>
      </td>
      <td class="text-center">
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ tasksCountPostfix(row, inboxjobsService.addressStr(row.from)) }}"
        >
          {{ tasksCountPostfix(row, inboxjobsService.addressStr(row.from)) }}
        </div>
      </td>
      <td class="text-center">
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ tasksCountPostfix(row, inboxjobsService.addressStr(row.to)) }}"
        >
          {{ tasksCountPostfix(row, inboxjobsService.addressStr(row.to)) }}
        </div>
      </td>
      <td>
        <div [class.job-unclicked]="!row.clicked" title="{{ row.pickupZoneName }}">
          {{ row.pickupZoneName }}
        </div>
      </td>
      <td>
        <div [class.job-unclicked]="!row.clicked" title="{{ row.deliveryZoneName }}">
          {{ row.deliveryZoneName }}
        </div>
      </td>
      <td
        *ngIf="
          inboxType != type_inboxCompletedJobs &&
          inboxType != type_inboxCancelled &&
          inboxType != type_inboxClosed
        "
      >
        <div
          [class.job-unclicked]="!row.clicked"
          pTooltip="Latest: {{ row.latestPickupDate | datex : 'ddd DD MMM \'YY HH:mm' }}"
        >
          {{ row.earliestPickupDate | datex : "ddd DD MMM 'YY HH:mm" }}
          {{ getPickupDropoffDiffHours(row, true) }}
        </div>
      </td>
      <td
        *ngIf="
          inboxType != type_inboxCompletedJobs &&
          inboxType != type_inboxCancelled &&
          inboxType != type_inboxClosed
        "
      >
        <div
          [class.job-unclicked]="!row.clicked"
          pTooltip="Latest: {{ row.latestDropOffDate | datex : 'ddd DD MMM \'YY HH:mm' }}"
        >
          {{ row.earliestDropOffDate | datex : "ddd DD MMM 'YY HH:mm" }}
          {{ getPickupDropoffDiffHours(row, false) }}
        </div>
      </td>
      <td>
        <div [class.job-unclicked]="!row.clicked" title="{{ row.movementType }}">
          {{ row.movementType }}
        </div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
      >
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ customersCountPostfix(row, row.customerName) }}"
        >
          {{ customersCountPostfix(row, row.customerName) }}
        </div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
        class="text-center"
      >
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ customersCountPostfix(row, row.customerDepartmentName) }}"
        >
          {{ customersCountPostfix(row, row.customerDepartmentName) }}
        </div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxDeploy ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
        class="text-center"
      >
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ customersCountPostfix(row, row.customerTeamName) }}"
        >
          {{ customersCountPostfix(row, row.customerTeamName) }}
        </div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxAwaitingStart ||
          inboxType == type_inboxCompletedJobs ||
          inboxType == type_inboxCancelled ||
          inboxType == type_inboxClosed ||
          inboxType == type_GlobalFilter
        "
      >
        {{ row.supplierName }}
      </td>
      <td *ngIf="inboxType != type_inboxDeploy" class="text-center">
        <div [class.job-unclicked]="!row.clicked">{{ row.vehiclesNum }}</div>
      </td>
      <td
        *ngIf="
          inboxType == type_inboxSupplierToBeConfirmed ||
          inboxType == type_inboxUrgentJobs ||
          inboxType == type_GlobalFilter
        "
      >
        <div [class.job-unclicked]="!row.clicked">
          {{ row.binCost | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxAwaitingStart || inboxType == type_inboxCompletedJobs">
        <div [class.job-unclicked]="!row.clicked">
          {{ row.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxCancelled || inboxType == type_inboxClosed">
        <div [class.job-unclicked]="!row.clicked">
          {{ row.total | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxCancelled || inboxType == type_inboxClosed">
        <div [class.job-unclicked]="!row.clicked">
          {{ row.supplierPaid | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </div>
      </td>
      <td
        *ngIf="
          inboxType != type_inboxCompletedJobs &&
          inboxType != type_inboxCancelled &&
          inboxType != type_inboxClosed
        "
      >
        <div [class.job-unclicked]="!row.clicked">
          <span
            pTooltip="Held: {{ row.createdOn | datex : 'ddd DD MMM \'YY HH:mm' }} - {{
              row.heldEndDate | datex : 'ddd DD MMM \'YY HH:mm'
            }}
                EC: {{ row.heldEndDate | datex : 'ddd DD MMM \'YY HH:mm' }} - {{
              row.exisingCapacityEndDate | datex : 'ddd DD MMM \'YY HH:mm'
            }}"
            >{{ row.statusName }}</span
          >
        </div>
      </td>
      <td *ngIf="inboxType == type_GlobalFilter">
        <div [class.job-unclicked]="!row.clicked">{{ row.inboxTabName }}</div>
      </td>
      <td
        *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
        class="text-center"
      >
        <div *ngIf="row.watchCount >= 0">{{ row.watchCount }}</div>
      </td>
      <td
        *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
        class="text-center"
      >
        <div *ngIf="row.supplierDirectedCount >= 0">{{ row.supplierDirectedCount }}</div>
      </td>
      <td *ngIf="inboxType == type_inboxDeploy">
        <div
          title="EC: {{ row.existingCapacityPrice }} | BIN: {{ row.binCost }}"
          [class.job-unclicked]="!row.clicked"
        >
          {{
            (row.statusHint == 'Existing Capacity' ? row.existingCapacityPrice : row.binCost)
              | currency : 'GBP' : 'symbol' : '1.2-2'
          }}
        </div>
      </td>
      <td *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy">
        <div
          [class.job-unclicked]="!row.clicked"
          title="{{ row.orderCreatedOn | datex : 'ddd DD MMM \'YY HH:mm' }}"
        >
          {{ row.orderCreatedOn | datex : "ddd DD MMM 'YY HH:mm" }}
        </div>
      </td>
      <!--      <td *ngIf="inboxType == type_inboxDeploy" style="width: 40px">-->
      <!--        <img-->
      <!--          *ngIf="row.isCapacityMatch || row.isSavedSearchMatch"-->
      <!--          src="assets/images/existent_capacity.png"-->
      <!--          style="vertical-align: middle"-->
      <!--          width="20"-->
      <!--          height="20"-->
      <!--          pTooltip="'Extended capacity match'"-->
      <!--        />-->
      <!--      </td>-->
    </tr>
  </ng-template>
</p-table>

<div class="footerPanel ui-grid-row">
  <button
    *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
    class="pull-right ui-sm-12 mt-1"
    type="button"
    [appOpenUrl]="'/app/job-deployment/' + selectedJob?.id"
    icon="fa fa-user-plus"
    label="Job Deployment"
    pButton
    [disabled]="!selectedJob || selectedJobs?.length > 1"
  ></button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="viewJob(this.selectedJob, $event, true)"
    icon="fa fa-list"
    label="Job Details"
    pButton
    [disabled]="!selectedJob || selectedJobs?.length > 1"
  ></button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="removeJobFromCombine(selectedJob)"
    icon="fa fa-eraser"
    label="Cancel Combine"
    pButton
    [disabled]="!selectedJob || selectedJobs?.length > 1"
    *ngIf="inboxType == type_inboxCombine"
  ></button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="combineJobs()"
    icon="fa fa-link"
    label="Combine"
    pButton
    [disabled]="page.items.length < 2"
    *ngIf="inboxType == type_inboxCombine"
  ></button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="uncombineJobs(selectedJob)"
    icon="fa fa-chain-broken"
    label="Uncombine"
    pButton
    [disabled]="!selectedJob || selectedJob.ordersCount < 2 || selectedJobs?.length > 1"
    *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
  ></button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="markSelectedJobsForCombine()"
    [icon]="markingForCombine ? 'pi pi-spinner pi-spin' : 'fa fa-thumb-tack'"
    label="Mark For Combine"
    pButton
    [disabled]="!selectedJob || selectedJobs?.length == 0 || markingForCombine"
    *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
  ></button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="markPriority(selectedJob)"
    icon="fa fa-thumb-tack"
    [label]="
      (selectedJob && selectedJob.priorityDeployment ? 'Unmark' : 'Mark') +
      ' for Priority Deployment'
    "
    pButton
    [disabled]="!selectedJob || selectedJobs?.length > 1"
    *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
  ></button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="downloadToCSV()"
    label="Download to CSV"
    icon="fa fa-cloud-download"
    pButton
  ></button>

  <button
    *ngIf="
      inboxType == type_inboxClosed ||
      inboxType == type_inboxCancelled ||
      inboxType == type_inboxCompletedJobs
    "
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="showPriceDetails()"
    icon="fa fa-info"
    label="Price Details"
    pButton
    [disabled]="!selectedJob"
  ></button>

  <button
    *ngIf="inboxType == type_inboxDeploy"
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="holdSelectedJobs()"
    [icon]="holdingJobs ? 'pi pi-spinner pi-spin' : 'fa fa-thumb-tack'"
    label="Hold"
    pButton
    [disabled]="!selectedJob || selectedJobs?.length == 0 || holdingJobs"
  ></button>

  <button
    *ngIf="inboxType == type_inboxDeploy"
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="releaseSelectedJobs()"
    [icon]="releasingJobs ? 'pi pi-spinner pi-spin' : 'fa fa-chain-broken'"
    label="Release"
    pButton
    [disabled]="!selectedJob || selectedJobs?.length == 0 || !allSelectedOnHold() || releasingJobs"
  ></button>

  <button
    *ngIf="inboxType == type_inboxDeploy"
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="enableGrabForSelectedJobs()"
    [icon]="enablingGrab ? 'pi pi-spinner pi-spin' : 'fa fa-hand-grab-o'"
    label="Enable Grab"
    pButton
    [disabled]="
      !selectedJob || selectedJobs?.length == 0 || anySelectedGrabEnabled() || enablingGrab
    "
  ></button>

  <button
    *ngIf="inboxType == type_inboxDeploy"
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="disableGrabForSelectedJobs()"
    [icon]="disablingGrab ? 'pi pi-spinner pi-spin' : 'fa fa-hand-stop-o'"
    label="Disable Grab"
    pButton
    [disabled]="
      !selectedJob || selectedJobs?.length == 0 || anySelectedGrabDisabled() || disablingGrab
    "
  ></button>

  <app-queue-auto-direct-button
    *ngIf="inboxType == type_inboxDeploy"
    class="pull-right ui-sm-12 mt-1"
    [jobIds]="selectedJobIds"
    [disabled]="!selectedJob || selectedJobs?.length == 0"
    (queued)="onAutoDirectQueued()"
  ></app-queue-auto-direct-button>

  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="loadRoutesInbox()"
    [label]="'Routes Inbox (in ' + routesContainingJobCount + ' routes)'"
    pButton
    [disabled]="!selectedJob || selectedJobs?.length != 1 || routesContainingJobCount == 0"
    *ngIf="inboxType == type_inboxSupplierToBeConfirmed || inboxType == type_inboxDeploy"
  ></button>
</div>

<span *ngIf="isLoading"
  ><span class="loading-notice"
    ><i class="fa fa-spin fa-2x fa-spinner"></i> &nbsp; Loading</span
  ></span
>

<ng-template #loading>Loading...</ng-template>

<ng-template #gradingDisplay let-grading>
  <span *ngIf="grading" [ngStyle]="{ color: grading.colour }" [class]="grading.iconClass"></span>
  {{ grading.description }}
</ng-template>

<p-dialog
  #premiumTimeBandsDialog
  header="Select Job Holding Period"
  [(visible)]="showHoldConfirmation"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <strong style="line-height: 26px">{{ selectedJobs?.length }} Jobs Selected</strong>
  <div style="margin-bottom: 30px">Select release date for selected jobs</div>

  <div style="display: flex; margin-bottom: 20px">
    <div class="flex-grow-1">Release Date & Time</div>
    <div class="flex-shrink-1">
      <p-calendar
        appendTo="body"
        [showTime]="true"
        [showIcon]="true"
        name="jobReleaseDate"
        styleClass="full-width-calendar"
        dateFormat="D d MM"
        hourFormat="24"
        [stepMinute]="30"
        [showSeconds]="false"
        [(ngModel)]="jobsReleaseDate"
        placeholder="Select Date & Time"
        [minDate]="jobsMinReleaseDate"
      ></p-calendar>
    </div>
  </div>
  <div style="margin-bottom: 20px; text-align: right">
    The selected jobs will <b>be held for {{ getReleaseDays() }}</b>
  </div>

  <div *ngIf="inboxType == type_inboxDeploy && anySelectedOnHold()" style="margin-bottom: 20px">
    Jobs already in hold will be extended to this date. Any held until later are left as they are.
  </div>

  <div
    style="display: flex; justify-content: flex-end; border-top: 1px solid grey; padding-top: 12px"
  >
    <button
      type="button"
      pButton
      class="ui-button-tertiary"
      label="Cancel"
      (click)="showHoldConfirmation = false"
    ></button>
    <button
      type="button"
      class="ui-button-primary"
      pButton
      (click)="doHoldJobs()"
      label="Confirm Hold"
    ></button>
  </div>
</p-dialog>

<combine-grab-disabled-job-dialog
  [(visible)]="showConfirmCombineDialog"
  (onConfirm)="confirmCombine()"
></combine-grab-disabled-job-dialog>
